import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from '@angular/router';
import {
  CurrentVenueHelperService
} from "../../../share-modul/services/current-venue-helper/current-venue.helper.service";
import * as moment from "moment/moment";
import { VenueService } from "../../services/venues/venue.service";
import { VenueModel } from "../../models/venues/venue.model";
import { UserModel } from "../../../share-modul/models/user/user.model";
import { AuthenticationService } from "../../../share-modul/services/authentication/authentication.service";
import { DivisionModel } from "../../models/divisions/division.model";
import { Router } from "@angular/router";
import { DashboardService } from 'src/api/generated/services';
import { GetTotalIncome$Params } from 'src/api/generated/fn/dashboard/get-total-income';
import { TotalIncomeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Bills/total-income-dto';
import { GetAllOrders$Params } from 'src/api/generated/fn/dashboard/get-all-orders';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

  public venueId: string;
  public venueIdUpdateSubscription: Subscription;
  public unsubscribe: Subject<void> = new Subject<void>();
  public venue: VenueModel = new VenueModel();
  public user: UserModel | null;
  public listDivisions: Array<DivisionModel> = new Array<DivisionModel>();
  currency: MenuCurrencyDto;

  public date: Date;
  public totalIncome: TotalIncomeDto;
  public allOrders: any;
  timezoneOffset: any;

  constructor(public currentVenueHelper: CurrentVenueHelperService,
              public router: Router,
              private venueService: VenueService,
              public dashboardService: DashboardService,
              public authenticationService: AuthenticationService,
              private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
      this.user = user;
    });

    this.date = new Date();

    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
          this.venueId = params['venue-id'];
          this.venueService.getvenuedetails(params['venue-id'], this.user?.roles)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(response => this.venue = response);
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(timezone => {
          if(timezone != undefined && timezone != this.timezoneOffset){
            this.timezoneOffset = timezone;
            this.getAllOrders();
            this.getTotalIncome();
          }
        });
      }else{
        this.currentVenueHelper.updateCurrentVenueIdDropdown(undefined);
      }
  });

  } 
  public onDateChange(){
    this.getAllOrders();
    this.getTotalIncome();
  }
  
  public getTotalIncome(){
    const params: GetTotalIncome$Params = { venueId: this.venueId, dateFrom: moment(this.date).utcOffset(this.timezoneOffset, true).startOf('day').toISOString(), dateTo: moment(this.date).utcOffset(this.timezoneOffset, true).endOf('day').toISOString() };
    this.dashboardService.getTotalIncome(params).subscribe(response => this.totalIncome = response);
  }
  public getAllOrders(){
    const params: GetAllOrders$Params = { venueId: this.venueId, dateFrom: moment(this.date).utcOffset(this.timezoneOffset, true).startOf('day').toISOString(), dateTo: moment(this.date).utcOffset(this.timezoneOffset, true).endOf('day').toISOString() };
    this.dashboardService.getAllOrders(params).subscribe(response => this.allOrders = response);
  }
  public navigateToMenuItems(id: string): void {
    this.router.navigate([this.venueId, 'dashboard', 'divisions', id, 'menu-items'], { queryParams: { date: moment(this.date).format('MM/DD/YYYY')} });
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
